// extracted by mini-css-extract-plugin
export default {"blueBtn":"buttonAnswer_blueBtn__S7hFA"};